<template>
  <div class="cont">
    <Navbar :dialogLoginVisible.sync="loginFormShow"></Navbar>
    <div class="d-flex" style="justify-content: center; position: relative">
      <div
        style="
          border-radius: 50%;
          width: 44px;
          height: 44px;
          justify-content: center;
          align-items: center;
          background: #1b1d2e;
          position: absolute;
          left: 0;
          top: 40px;
          z-index: 9;
          cursor: pointer;
        "
        class="d-flex"
        @click="homeBack"
      >
        <el-image
          style="height: 24px; width: 24px"
          :src="require('../assets/img/explore/back.png')"
        >
          <div slot="placeholder" class="image-slot"></div>
        </el-image>
      </div>

      <div class="info_cont d-flex">
        <div class="l" style="position: relative">
          <el-image
            style="height: 470px; border-radius: 20px 0px 0px 20px"
            :src="url"
            v-if="url"
            class="images_"
            v-viewer="{
              movable: true,
              navbar: false,
              toolbar: true,
              title: false,
              fullscreen: false,
              rotatable: false,
              scalable: false,
            }"
          >
            <!-- <div slot="placeholder" class="image-slot"></div> -->
          </el-image>
          <div
            @click="carouselClick"
            style="
              position: absolute;
              right: 10px;
              top: 10px;
              cursor: pointer;
              justify-content: center;
              align-items: center;
              width: 40px;
              height: 40px;
              background: rgba(0, 0, 0, 0.5);
              border-radius: 6px;
              z-index: 9;
            "
            class="d-flex"
          >
            <el-image
              style="width: 20px; height: 20px"
              :src="require('../assets/img/textform/fullscreen.png')"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </el-image>
          </div>
        </div>
        <div class="r">
          <div
            class="line d-flex"
            style="align-items: center; margin-bottom: 10px"
          >
            <el-image
              style="
                width: 30px;
                height: 30px;
                border-radius: 50%;
                margin-right: 6px;
              "
              @click.stop="gotoPersonal(resdata)"
              v-if="resdata && resdata.ownerPhoto"
              :src="resdata.ownerPhoto"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </el-image>
            <el-image
              style="width: 30px; height: 30px; margin-right: 6px"
              @click.stop="gotoPersonal(resdata)"
              v-else
              :src="require('../assets/img/ava.png')"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </el-image>

            <div
              style="
                flex: 1;
                position: relative;
                box-sizing: border-box;
                align-items: center;
              "
              class="uname d-flex"
            >
              <div
                @click.stop="gotoPersonal(resdata)"
                style="
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  max-width: 150px;
                "
              >
                {{ resdata ? resdata.uname : "" }}
              </div>
              <el-image
                style="
                  width: 26px;
                  height: 14px;
                  margin-right: 2px;
                  margin-left: 2px;
                "
                :src="require('../assets/img/waterfall/vip.png')"
                fit="contain"
                v-if="resdata && resdata.ownerIsVip"
                @click.stop="gotoPersonal(resdata)"
              >
                <div slot="placeholder" class="image-slot"></div>
              </el-image>

              <template
                v-if="
                  resdata &&
                  ac_data.uid != resdata.uid &&
                  ac_data.uid != resdata.uid
                "
              >
                <el-button
                  round
                  size="mini"
                  style="
                    width: 60px;
                    color: #9a9ab7;
                    background: #252739;
                    border: none;
                    margin-left: 4px;
                    padding: 7px 0;
                  "
                  v-if="gz"
                  @click.stop="cancelGz"
                  >已关注</el-button
                >
                <el-button
                  round
                  size="mini"
                  style="
                    width: 60px;
                    color: #006fff;
                    background: #252739;
                    border: none;
                    margin-left: 4px;
                    padding: 7px 0;
                  "
                  v-else
                  @click.stop="addGz"
                  >关注</el-button
                >
              </template>
            </div>
            <el-image
              style="width: 18px; height: 18px; margin-right: 12px"
              @click="like_edit(1, resdata)"
              :src="require('../assets/img/waterfall/good_a.png')"
              v-show="resdata && resdata.like"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </el-image>
            <el-image
              style="width: 18px; height: 18px; margin-right: 12px"
              @click="like_edit(0, resdata)"
              :src="require('../assets/img/waterfall/good.png')"
              v-show="resdata && !resdata.like"
              fit="contain"
            >
              <div slot="placeholder" class="image-slot"></div>
            </el-image>

            <el-tooltip
              popper-class="tps"
              class="item"
              effect="dark"
              :enterable="false"
              content="分享"
              placement="bottom"
            >
              <el-image
                style="width: 22px; height: 22px; margin-right: 12px"
                @click="shareImg"
                :src="require('../assets/img/explore/share.png')"
                fit="contain"
              >
                <div slot="placeholder" class="image-slot"></div>
              </el-image>
            </el-tooltip>

            <!-- @click="download_click" -->
            <el-tooltip
              popper-class="tps download_pop"
              class="item"
              effect="dark"
              :enterable="true"
              content="下载"
              placement="bottom"
            >
              <div slot="content" style="width: 325px">
                <div
                  style="
                    height: 22px;
                    display: flex;
                    align-items: center;
                    width: 275px;
                    padding-bottom: 10px;
                  "
                  v-if="ac_data && !ac_data.vip"
                >
                  <div style="flex: 1">下载图片（有水印）</div>

                  <div
                    @click="download_click(true)"
                    style="
                      width: 55px;
                      height: 22px;
                      background: #111225;
                      border-radius: 11px;
                      line-height: 22px;
                      text-align: center;
                      font-size: 12px;
                      color: #cacad4;
                      cursor: pointer;
                    "
                  >
                    下载
                  </div>
                </div>

                <div
                  style="
                    height: 1px;
                    background-color: #343249;
                    width: 275px;
                    margin-bottom: 10px;
                  "
                ></div>

                <div
                  style="
                    height: 22px;
                    display: flex;
                    align-items: center;
                    width: 275px;
                    margin-bottom: 10px;
                  "
                  v-if="ac_data && !ac_data.vip"
                >
                  <div style="flex: 1">下载图片（无水印）</div>

                  <div
                    @click="download_click(false)"
                    style="
                      width: 54px;
                      height: 22px;
                      background: #006fff;
                      border-radius: 11px;
                      line-height: 22px;
                      text-align: center;
                      font-size: 12px;
                      color: #cacad4;
                      cursor: pointer;
                    "
                  >
                    2积分
                  </div>
                </div>

                <div
                  style="
                    height: 22px;
                    display: flex;
                    align-items: center;
                    width: 275px;
                    margin-bottom: 10px;
                  "
                  v-if="ac_data && ac_data.vip"
                >
                  <div style="flex: 1">下载图片（VIP免积分下载）</div>

                  <div
                    @click="download_click(false)"
                    style="
                      width: 54px;
                      height: 22px;
                      background: #006fff;
                      border-radius: 11px;
                      line-height: 22px;
                      text-align: center;
                      font-size: 12px;
                      color: #cacad4;
                      cursor: pointer;
                    "
                  >
                    下载
                  </div>
                </div>

                <div style="color: #9a9ab7">
                  1.下载创作者发布的AI创作原图每次需要消耗2积分；
                </div>
                <div style="color: #9a9ab7">
                  2.下载的原图仅供个人学习研究使用，严禁商用。
                </div>
              </div>

              <el-image
                style="width: 22px; height: 22px; margin-right: 2px"
                :src="require('../assets/img/explore/download.png')"
                fit="contain"
              >
                <div slot="placeholder" class="image-slot"></div>
              </el-image>
            </el-tooltip>

           <!--  <el-button
              type="primary"
              round
              style="background: #006fff; margin-left: 12px"
              @click="apply_click"
              >应用</el-button
            > -->

            <!-- <el-button type="primary" round style="background: #fff;color: #000;" @click="download_click">下载</el-button>
             -->
          </div>
          <div
            class="line d-flex"
            style="align-items: center; margin-bottom: 10px"
          >
            <span
              style="
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #fff;
                line-height: 22px;
                margin-right: 12px;
              "
              >提示词</span
            >
            <div
              style="
                font-size: 11px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #cacad4;
                line-height: 16px;
                align-items: center;
                flex: 1;
              "
              class="d-flex"
            >
              <el-image
                style="
                  width: 14px;
                  height: 14px;
                  margin-right: 2px;
                  cursor: pointer;
                "
                :src="require('../assets/img/explore/copy.png')"
                fit="contain"
                @click="copy(params.prompt)"
              >
                <div slot="placeholder" class="image-slot"></div>
              </el-image>
              <span style="cursor: pointer" @click="copy(params.prompt)">
                复制
              </span>
            </div>

            <!-- <el-button type="primary" round style="background: #fff;color: #000;" @click="download_click">下载</el-button>
            <el-button type="primary" round style="background: #006FFF;" @click="apply_click">应用</el-button> -->
          </div>
          <div
            class="cont2"
            style="
              width: 434px;
              height: 131px;
              background: #111225;
              border-radius: 10px;
              padding: 16px 13px;
              box-sizing: border-box;
              font-size: 13px;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #cacad4;
              margin-bottom: 16px;
              overflow: auto;
            "
          >
            {{ params.prompt }}
          </div>
          <div
            class="cont2 info"
            style="
              width: 434px;
              height: 210px;
              background: #111225;
              border-radius: 10px;
              padding: 16px 13px;
              box-sizing: border-box;
              font-size: 13px;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #cacad4;
              margin-bottom: 16px;
              overflow: auto;
            "
          >
            <el-tabs v-model="activeName" style="height: 100%">
              <el-tab-pane name="1" style="height: 100%">
                <span slot="label">
                  <div class="title t1"><span>基础信息</span></div>
                </span>
                <div class="d-flex" style="flex-wrap: wrap">
                  <div
                    class="infocont"
                    style="
                      width: 50%;
                      margin-bottom: 9px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      padding-right: 5px;
                      box-sizing: border-box;
                    "
                    v-if="md_list_data.length > 0"
                  >
                    <el-image
                      style="
                        width: 12px;
                        height: 12px;
                        margin-right: 3px;
                        cursor: pointer;
                      "
                      :src="require('../assets/img/explore/round.png')"
                      fit="contain"
                    >
                      <div
                        slot="placeholder"
                        class="image-slot"
                      ></div> </el-image
                    >模型<span class="value">{{ modelname }}</span>
                  </div>
                  <div
                    class="infocont"
                    style="
                      width: 50%;
                      margin-bottom: 9px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      padding-right: 5px;
                      box-sizing: border-box;
                    "
                    v-if="st_list_data.length > 0"
                  >
                    <el-image
                      style="
                        width: 12px;
                        height: 12px;
                        margin-right: 3px;
                        cursor: pointer;
                      "
                      :src="require('../assets/img/explore/round.png')"
                      fit="contain"
                    >
                      <div
                        slot="placeholder"
                        class="image-slot"
                      ></div> </el-image
                    >风格<span class="value">{{ stylename }}</span>
                  </div>
                  <div
                    class="infocont"
                    style="
                      width: 50%;
                      margin-bottom: 9px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      padding-right: 5px;
                      box-sizing: border-box;
                    "
                    v-if="featurename"
                    :title="featurename"
                  >
                    <el-image
                      style="
                        width: 12px;
                        height: 12px;
                        margin-right: 3px;
                        cursor: pointer;
                      "
                      :src="require('../assets/img/explore/round.png')"
                      fit="contain"
                    >
                      <div
                        slot="placeholder"
                        class="image-slot"
                      ></div> </el-image
                    >智能调节<span class="value">{{ featurename }}</span>
                  </div>
                  <div
                    class="infocont"
                    style="
                      width: 50%;
                      margin-bottom: 9px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      padding-right: 5px;
                      box-sizing: border-box;
                    "
                  >
                    <el-image
                      style="
                        width: 12px;
                        height: 12px;
                        margin-right: 3px;
                        cursor: pointer;
                      "
                      :src="require('../assets/img/explore/round.png')"
                      fit="contain"
                    >
                      <div
                        slot="placeholder"
                        class="image-slot"
                      ></div> </el-image
                    >尺寸<span class="value"
                      >{{ params.width }}*{{ params.height }}</span
                    >
                  </div>
                  <div
                    class="infocont"
                    style="
                      width: 50%;
                      margin-bottom: 9px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      padding-right: 5px;
                      box-sizing: border-box;
                    "
                  >
                    <el-image
                      style="
                        width: 12px;
                        height: 12px;
                        margin-right: 3px;
                        cursor: pointer;
                      "
                      :src="require('../assets/img/explore/round.png')"
                      fit="contain"
                    >
                      <div
                        slot="placeholder"
                        class="image-slot"
                      ></div> </el-image
                    >时间<span class="value">{{ params.createdAt }}</span>
                  </div>
                  <div
                    class="infocont"
                    style="
                      width: 50%;
                      margin-bottom: 9px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      padding-right: 5px;
                      box-sizing: border-box;
                    "
                  >
                    <el-image
                      style="
                        width: 12px;
                        height: 12px;
                        margin-right: 3px;
                        cursor: pointer;
                      "
                      :src="require('../assets/img/explore/round.png')"
                      fit="contain"
                    >
                      <div
                        slot="placeholder"
                        class="image-slot"
                      ></div> </el-image
                    >面部修复<span class="value">{{
                      params.restore_faces ? "开启" : "关闭"
                    }}</span>
                  </div>
                  <div
                    class="infocont"
                    style="
                      width: 50%;
                      margin-bottom: 9px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      padding-right: 5px;
                      box-sizing: border-box;
                    "
                  >
                    <el-image
                      style="
                        width: 12px;
                        height: 12px;
                        margin-right: 3px;
                        cursor: pointer;
                      "
                      :src="require('../assets/img/explore/round.png')"
                      fit="contain"
                    >
                      <div
                        slot="placeholder"
                        class="image-slot"
                      ></div> </el-image
                    >高分辨率修复<span class="value">{{
                      params.enable_hr ? "开启" : "关闭"
                    }}</span>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane name="2" style="height: 100%" v-bar>
                <span slot="label">
                  <div class="title t2"><span>高级信息</span></div>
                </span>
                <div class="d-flex" style="flex-wrap: wrap">
                  <div
                    class="infocont"
                    style="
                      width: 50%;
                      margin-bottom: 9px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      padding-right: 5px;
                      box-sizing: border-box;
                    "
                  >
                    <el-image
                      style="
                        width: 12px;
                        height: 12px;
                        margin-right: 3px;
                        cursor: pointer;
                      "
                      :src="require('../assets/img/explore/round.png')"
                      fit="contain"
                    >
                      <div
                        slot="placeholder"
                        class="image-slot"
                      ></div> </el-image
                    >步数<span class="value">{{ params.steps }}</span>
                  </div>
                  <div
                    class="infocont"
                    style="
                      width: 50%;
                      margin-bottom: 9px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      padding-right: 5px;
                      box-sizing: border-box;
                    "
                  >
                    <el-image
                      style="
                        width: 12px;
                        height: 12px;
                        margin-right: 3px;
                        cursor: pointer;
                      "
                      :src="require('../assets/img/explore/round.png')"
                      fit="contain"
                    >
                      <div
                        slot="placeholder"
                        class="image-slot"
                      ></div> </el-image
                    >采样器<span class="value">{{ samplername }}</span>
                  </div>
                  <div
                    class="infocont"
                    style="
                      width: 50%;
                      margin-bottom: 9px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      padding-right: 5px;
                      box-sizing: border-box;
                    "
                  >
                    <el-image
                      style="
                        width: 12px;
                        height: 12px;
                        margin-right: 3px;
                        cursor: pointer;
                      "
                      :src="require('../assets/img/explore/round.png')"
                      fit="contain"
                    >
                      <div
                        slot="placeholder"
                        class="image-slot"
                      ></div> </el-image
                    >重绘强度<span class="value">{{
                      params.denoising_strength
                    }}</span>
                  </div>
                  <div
                    class="infocont"
                    style="
                      width: 50%;
                      margin-bottom: 9px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      padding-right: 5px;
                      box-sizing: border-box;
                    "
                  >
                    <el-image
                      style="
                        width: 12px;
                        height: 12px;
                        margin-right: 3px;
                        cursor: pointer;
                      "
                      :src="require('../assets/img/explore/round.png')"
                      fit="contain"
                    >
                      <div
                        slot="placeholder"
                        class="image-slot"
                      ></div> </el-image
                    >放大倍率<span class="value">{{ params.hr_scale }}</span>
                  </div>
                  <div
                    class="infocont"
                    style="
                      width: 50%;
                      margin-bottom: 9px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      padding-right: 5px;
                      box-sizing: border-box;
                    "
                  >
                    <el-image
                      style="
                        width: 12px;
                        height: 12px;
                        margin-right: 3px;
                        cursor: pointer;
                      "
                      :src="require('../assets/img/explore/round.png')"
                      fit="contain"
                    >
                      <div
                        slot="placeholder"
                        class="image-slot"
                      ></div> </el-image
                    >高分辨率采样步数<span class="value">{{
                      params.hr_second_pass_steps
                    }}</span>
                  </div>
                  <div
                    class="infocont"
                    style="
                      width: 50%;
                      margin-bottom: 9px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      padding-right: 5px;
                      box-sizing: border-box;
                    "
                  >
                    <el-image
                      style="
                        width: 12px;
                        height: 12px;
                        margin-right: 3px;
                        cursor: pointer;
                      "
                      :src="require('../assets/img/explore/round.png')"
                      fit="contain"
                    >
                      <div
                        slot="placeholder"
                        class="image-slot"
                      ></div> </el-image
                    >高清化算法<span class="value">{{ hrupscalername }}</span>
                  </div>
                  <div
                    class="infocont"
                    style="
                      width: 50%;
                      margin-bottom: 9px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      padding-right: 5px;
                      box-sizing: border-box;
                    "
                  >
                    <el-image
                      style="
                        width: 12px;
                        height: 12px;
                        margin-right: 3px;
                        cursor: pointer;
                      "
                      :src="require('../assets/img/explore/round.png')"
                      fit="contain"
                    >
                      <div
                        slot="placeholder"
                        class="image-slot"
                      ></div> </el-image
                    >提示词引导系数<span class="value">{{
                      params.cfg_scale
                    }}</span>
                  </div>
                  <div
                    class="infocont"
                    style="
                      width: 50%;
                      margin-bottom: 9px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      padding-right: 5px;
                      box-sizing: border-box;
                    "
                  >
                    <el-image
                      style="
                        width: 12px;
                        height: 12px;
                        margin-right: 3px;
                        cursor: pointer;
                      "
                      :src="require('../assets/img/explore/round.png')"
                      fit="contain"
                    >
                      <div
                        slot="placeholder"
                        class="image-slot"
                      ></div> </el-image
                    >种子数<span class="value">{{ params.seed }}</span>
                  </div>
                  <div
                    class="infocont"
                    style="
                      width: 50%;
                      margin-bottom: 9px;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      padding-right: 5px;
                      box-sizing: border-box;
                    "
                  >
                    <el-image
                      style="
                        width: 12px;
                        height: 12px;
                        margin-right: 3px;
                        cursor: pointer;
                      "
                      :src="require('../assets/img/explore/round.png')"
                      fit="contain"
                    >
                      <div
                        slot="placeholder"
                        class="image-slot"
                      ></div> </el-image
                    >负指令
                  </div>
                  <div
                    style="
                      min-height: 62px;
                      width: 100%;
                      background: #252739;
                      border-radius: 4px;
                      border: 1px solid #2c2f42;
                      padding: 4px 10px;
                      box-sizing: border-box;
                      font-size: 13px;
                      font-family: PingFangSC-Regular, PingFang SC;
                      color: #9a9ab7;
                      line-height: 18px;
                    "
                  >
                    {{ params.negative_prompt }}
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>

    <div
      style="
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 33px;
        margin-top: 28px;
        text-align: center;
        margin-bottom: 16px;
      "
    >
      相关推荐
    </div>

    <MyWaterfall
      @loginFormShowChange="loginFormShowChange"
      :model="params ? params.model : ''"
    ></MyWaterfall>

    <LoginForm
      :dialogLoginVisible.sync="loginFormShow"
      v-if="loginFormShow"
    ></LoginForm>

    <ElBacktop></ElBacktop>
    <Carousel
      :dialogCarouselVisible.sync="carouselShow"
      :dialogImgArr.sync="dialogImgArr"
      :imgIdx.sync="imgIdx"
      v-if="carouselShow"
    ></Carousel>

    <ShareCont
      :dialogShareVisible.sync="shareShow"
      :shareValue="shareValue"
      :shareImgMd5="shareImgMd5"
      :imgUrl="url ? url : ''"
    >
    </ShareCont>
    <Status></Status>
  </div>
</template>

<script>
import { md_list, st_list, feature_name } from "@/api/taskImage";
import { copyToClip, compress } from "@/utils/bose";
import {
  square_detail,
  like_edit_req,
  painting_download_req,
} from "@/api/square";
import { painting_detail_req, painting_home_req } from "@/api/personal";
import { user_invoke_req, user_account_req, event_log_req } from "@/api/user";
import { growth_tasks_req, growth_publish_req } from "@/api/task";
import { interest_edit_req } from "@/api/group";

import Navbar from "@/components/Navbar";
import LoginForm from "@/components/LoginForm";
import MyWaterfall from "@/components/MyWaterfall";
import Carousel from "@/components/Carousel";
import ElBacktop from "@/components/ElBacktop";
import ShareCont from "@/components/ShareCont";
import { getUUID } from "@/utils/bose";
import md5 from "js-md5";
import Status from "@/components/Status";

export default {
  components: {
    Status,
    Navbar,
    LoginForm,
    MyWaterfall,
    Carousel,
    ElBacktop,
    ShareCont,
  },
  data() {
    return {
      activeName: "1",
      params: {},
      resdata: undefined,
      url: "",

      md_list_data: [],
      st_list_data: [],
      feature_list_data: [],
      modelname: undefined,
      stylename: "不限",
      featurename: undefined,
      samplername: undefined,
      hrupscalername: undefined,
      loginFormShow: false,
      shareShow: false, //分享模块是否展示
      shareValue: undefined,
      shareImgMd5: undefined,
      sampler_name_options: [
        { text: "Euler a", value: "Euler a" },
        { text: "Euler", value: "Euler" },
        { text: "LMS", value: "LMS" },
        { text: "Heun", value: "Heun" },
        { text: "DPM2", value: "DPM2" },
        { text: "DPM2 a", value: "DPM2 a" },
        { text: "DPM++ 2S a", value: "DPM++ 2S a" },
        { text: "DPM++ 2M", value: "DPM++ 2M" },
        { text: "DPM++ SDE", value: "DPM++ SDE" },
        { text: "DPM fast", value: "DPM fast" },
        { text: "DPM adaptive", value: "DPM adaptive" },
        { text: "LMS Karras", value: "LMS Karras" },
        { text: "DPM2 Karras", value: "DPM2 Karras" },
        { text: "DPM2 a Karras", value: "DPM2 a Karras" },
        { text: "DPM++ 2S a Karras", value: "DPM++ 2S a Karras" },
        { text: "DPM++ 2M Karras", value: "DPM++ 2M Karras" },
        { text: "DPM++ SDE Karras", value: "DPM++ SDE Karras" },
        { text: "DDIM", value: "DDIM" },
        { text: "PLMS", value: "PLMS" },
        { text: "UniPC", value: "UniPC" },
      ],
      hr_upscaler_options: [
        { text: "Latent", value: "Latent" },
        { text: "Latent (antialiased)", value: "Latent (antialiased)" },
        { text: "Latent (bicubic)", value: "Latent (bicubic)" },
        {
          text: "Latent (bicubic antialiased)",
          value: "Latent (bicubic antialiased)",
        },
        { text: "Latent (nearest)", value: "Latent (nearest)" },
        { text: "Latent (nearest-exact)", value: "Latent (nearest-exact)" },
        { text: "None", value: "None" },
        { text: "LDSR", value: "LDSR" },
        { text: "Lanczos", value: "Lanczos" },
        { text: "Nearest", value: "Nearest" },
        { text: "ESRGAN_4x", value: "ESRGAN_4x" },
        { text: "R-ESRGAN 4x+", value: "R-ESRGAN 4x+" },
        { text: "R-ESRGAN 4x+ Anime6B", value: "R-ESRGAN 4x+ Anime6B" },
        { text: "ScuNET GAN", value: "ScuNET GAN" },
        { text: "ScuNET PSNR", value: "ScuNET PSNR" },
        { text: "SwimIR 4x", value: "SwimIR 4x" },
      ],
      carouselShow: false, //大图显示框
      dialogImgArr: [],
      imgIdx: 0,
      ac_data: {}, //账户信息

      gz: false,
      imgMd5: undefined,
    };
  },
  computed: {
    tokenVuex() {
      // 存储位置： store.state.{模块名,在store/index.js中module下的}.{state中定义的属性}
      return this.$store.state.user.token;
    },
  },
  mounted() {
    window.addEventListener("resize", this.resize, false);

    // this.params = this.$route.params;
    // this.url = this.params.url
    if (!this.$route.query.params) {
      this.$router.replace({ path: "/" });
      return;
    }
    return new Promise((resolve, reject) => {
      if (this.$route.query.personal == 1) {
        painting_detail_req(this.$route.query.params).then((res) => {
          this.params = JSON.parse(res.data.request);
          this.resdata = res.data;
          this.params.createdAt = res.data.createdAt;
          this.url = res.data.url;
          this.params.url = res.data.url;
          this.imgMd5 = res.data.imgMd5;
          if (!this.url) {
            this.$router.replace({ path: "/" });
            return;
          }

          resolve();
        });
      } else {
        square_detail(this.$route.query.params).then((res) => {
          this.params = JSON.parse(res.data.request);
          this.resdata = res.data;
          this.params.createdAt = res.data.createdAt;
          this.url = res.data.url;
          this.params.url = res.data.url;
          this.imgMd5 = res.data.imgMd5;
          if (!this.url) {
            this.$router.replace({ path: "/" });
            return;
          }
          resolve();
        });
      }
    }).then(() => {
      this.md_list_req();
      this.getsamplername();
      this.gethrupscaler();
      this.getUserAccountInfo();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    btoaFunc(val) {
      return val;
    },
    async getUserAccountInfo() {
      const { data, success } = await user_account_req();
      if (success) {
        if (data.ext) {
          data.ext = JSON.parse(data.ext);
          this.adultSwitch =
            data.ext && data.ext.adultSwitch ? data.ext.adultSwitch : false;
        }
        this.ac_data = data;
        if (
          this.ac_data.uid != this.resdata.uid &&
          this.ac_data.uid != this.resdata.uid
        ) {
          painting_home_req({
            uid: this.resdata.uid,
          }).then((_res) => {
            this.gz = _res.data.gz;
          });
        }
      }
      this.timestamp = Date.parse(new Date());
    },
    event_active_log(page) {
      let cnl = localStorage.getItem("cc")
        ? localStorage.getItem("cc") + "-pc"
        : "none-pc";
      let uid = this.ac_data.uid ? this.ac_data.uid : getUUID();
      var ts = Date.parse(new Date());
      let detail_str = JSON.stringify({ page: page });
      let sign = md5(
        "cnl" +
          cnl +
          "detail" +
          detail_str +
          "event" +
          "active" +
          "ts" +
          ts +
          "uid" +
          uid +
          "yEBgmO69"
      );
      event_log_req({
        // category : '' ,
        cnl: cnl,
        detail: detail_str,
        event: "active",
        ts: ts,
        uid: uid,
        sign: sign,
      });
    },
    shareImg() {
      this.$store.commit("user/change_token");
      if (!this.tokenVuex) {
        this.loginFormShow = true;
        this.$emit("loginFormShowChange", true);
        return;
      }

      if (this.src === null) {
        this.$toast.open({
          message: "违规图片无法分享",
          position: "top",
          duration: 3000,
          type: "default",
        });
        return;
      }
      this.$prompt("", "分享图展示信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "输入标题会更受欢迎哦（可选）",
        inputErrorMessage: "标题最多20字哦",
        inputPattern: /^(a-z|A-Z|0-9)*[^$%^&*;:,<>?()\""\']{0,20}$/,
        center: true,
        customClass: "_message_box",
      })
        .then(({ value }) => {
          this.shareValue = value ? value : "";
          this.shareImgMd5 = this.imgMd5 ? this.imgMd5 : "";
          this.shareShow = true;
          growth_publish_req({ type: 4 }).then(() => {
            growth_tasks_req({ type: 4 }).then((res1) => {
              if (res1.data[0].total >= res1.data[0].count) {
                setTimeout(() => {
                  this.$toast.open({
                    message: "分享成功，2积分已到账",
                    position: "top",
                    duration: 3000,
                    type: "success",
                  });
                }, 1000);
              }
            });
          });
        })
        .catch(() => {});

      //this.shareShow = true ;
    },
    copy(text) {
      copyToClip(text).then((res) => {
        this.$toast.open({
          message: "复制成功",
          position: "top",
          duration: 3000,
          type: "success",
        });
      });
    },
    //获取模型列表
    async md_list_req() {
      const { data, success } = await md_list();
      if (success && data && data.length > 0) {
        this.md_list_data = data;
        data.forEach((val) => {
          if (val.code == this.params.model) {
            this.modelname = val.name;
          }
        });

        if (this.params.style) {
          const { data: sdata, success: s_success } = await st_list({
            pcode: this.params.model,
          });
          if (s_success && sdata && sdata.length > 0) {
            this.st_list_data = sdata;
            let arr = [];
            sdata.forEach((_val) => {
              if (this.params.style.indexOf(_val.scode) > -1) {
                arr.push(_val.sname);
              }
            });
            if (arr.length > 0) {
              this.stylename = arr.join(",");
            }
          }
        }

        if (this.params.feature) {
          const { data: fdata, success: f_success } = await feature_name();
          if (f_success && fdata && fdata.length > 0) {
            this.feature_list_data = fdata;
            let arr = [];
            this.params.feature.split(",").forEach((_feature) => {
              fdata.forEach((_val) => {
                if (_val.code == _feature) {
                  arr.push(_val.name);
                }
              });
            });

            if (arr.length > 0) {
              let str = "";
              this.params.feature_ratio.split(",").forEach((val, idx) => {
                if (val != 0) {
                  str += arr[idx] + ":" + val + ",";
                }
              });
              if (str) {
                str = str.substring(0, str.length - 1);
                this.featurename = str;
              } else {
                this.featurename = "";
              }
            }
          }
        }
      }
    },
    getsamplername() {
      this.sampler_name_options.forEach((val) => {
        if (val.value == this.params.sampler_name) {
          this.samplername = val.text;
        }
      });
    },
    gethrupscaler() {
      this.hr_upscaler_options.forEach((val) => {
        if (val.value == this.params.hr_upscaler) {
          this.hrupscalername = val.text;
        }
      });
    },
    apply_click() {
      this.$store.commit("user/change_token");
      if (!this.tokenVuex) {
        this.loginFormShow = true;
        return;
      }

      if (this.resdata.category === 0) {
        this.params.url = undefined;
        this.params.createdAt = undefined;
        this.$router.replace({
          name: "textImage", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
          params: this.params,
        });
      } else if (this.resdata.category === 1) {
        this.$router.replace({
          name: "imageToImage", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
          params: this.params,
        });
      }

      // this.$router.push({
      //   name: "textImage", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
      //   params: this.params
      // });
    },
    download_click(flag) {
      this.$store.commit("user/change_token");
      if (!this.tokenVuex) {
        this.loginFormShow = true;
        this.$emit("loginFormShowChange", true);
        return;
      }

      // painting_download_req(  )
      painting_download_req({
        imgMd5: this.imgMd5,
        isMask: flag,
      }).then((res) => {
        console.log(res);
        const image = new Image();
        image.setAttribute("crossOrigin", "anonymous");
        image.src = res.data;
        image.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(image, 0, 0, image.width, image.height);
          const url = canvas.toDataURL("image/png");
          const a = document.createElement("a");
          a.href = url;
          a.download = "image.png";
          a.click();
        };
      });

      return;
    },
    loginFormShowChange(data) {
      this.loginFormShow = data;
    },
    homeBack() {
      // this.$router.push({
      //   path: `/`,
      // })
      this.$router.go(-1);
    },
    carouselClick() {
      // this.dialogImgArr = []
      // this.dialogImgArr.push({ image :  this.url })
      // this.carouselShow = true ;

      //获取viewer实例
      const viewer = this.$el.querySelector(".images_").$viewer;
      //调用show方法进行显示预览图
      viewer.show();
    },
    like_edit(flag, item) {
      this.$store.commit("user/change_token");
      if (!this.tokenVuex) {
        this.loginFormShow = true;
        this.$emit("loginFormShowChange", true);
        return;
      }
      this.loading = true;
      like_edit_req({
        imgId: item.id,
        status: flag,
        owner: item.uid,
        imgMd5: item.imgMd5,
      })
        .then((res) => {
          if (flag == 0) {
            this.resdata.like = true;
            growth_tasks_req({ type: 3 }).then((res1) => {
              if (res1.data[0].total >= res1.data[0].count) {
                setTimeout(() => {
                  this.$toast.open({
                    message: "点赞成功，3积分已到账",
                    position: "top",
                    duration: 3000,
                    type: "success",
                  });
                }, 1000);
              }
            });
          } else {
            this.resdata.like = false;
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    gotoPersonal(item) {
      let obj = {};
      obj.router = "personal";
      obj.uid = item.uid;
      this.$router.push({
        name: "test", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
        params: obj,
      });
    },
    cancelGz() {
      this.$store.commit("user/change_token");
      if (!this.tokenVuex) {
        this.loginFormShow = true;
        this.$emit("loginFormShowChange", true);
        return;
      }

      interest_edit_req({
        status: 2,
        fid: this.resdata.uid,
      }).then(() => {
        this.gz = false;
      });
    },
    addGz() {
      this.$store.commit("user/change_token");
      if (!this.tokenVuex) {
        this.loginFormShow = true;
        this.$emit("loginFormShowChange", true);
        return;
      }
      interest_edit_req({
        status: 1,
        fid: this.resdata.uid,
      }).then(() => {
        this.gz = true;
      });
    },
    resize() {
      console.log(123312);
      this.$store.commit("user/change_size", true);
    },
  },
  watch: {
    tokenVuex(newQuestion, oldQuestion) {
      // console.log( newQuestion )
      if (!newQuestion) {
        this.loginFormShow = true;
      } else {
        let page = undefined;
        if (this.$route.name == "home") {
          page = "home";
        } else if (this.$route.name == "aiQa") {
          page = "qa";
        } else if (this.$route.name == "textImage") {
          page = "textimage";
        } else if (this.$route.name == "imageToImage") {
          page = "imageimage";
        } else if (this.$route.name == "explore") {
          page = "explore";
        } else if (this.$route.name == "Personal") {
          page = "personal";
        }

        this.getUserAccountInfo().then(() => {
          if (page) {
            this.event_active_log(page);
          }
        }); //获取账户信息
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cont {
  padding: 60px 84px 0;
  box-sizing: border-box;
}

.info_cont {
  min-width: 500px;
  height: 470px;
  background: #1b1d2e;
  border-radius: 20px;
  margin: 0 auto;
  margin-top: 40px;
  .r {
    width: 464px;
    padding: 12px 15px;
    box-sizing: border-box;
  }
}

.info {
  text-align: left;
  padding: 12px;
  box-sizing: border-box;
  font-size: 14px;
  overflow: hidden;
  height: 100%;
  background: #111225;

  .title {
    box-sizing: border-box;
    padding: 0 15px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    position: relative;
  }

  ::v-deep .el-tabs__item.is-active .title:after {
    content: "";
    display: block;
    width: 20px;
    height: 4px;
    background: #006fff;
    border-radius: 2px;
    position: absolute;
    bottom: 2px;
  }
  ::v-deep .el-tabs__item.is-active .t1:after {
    left: 38px;
  }

  ::v-deep .el-tabs__item.is-active .t2:after {
    left: 38px;
  }

  .scroll-cont {
    margin-top: 8px;
    height: calc(100% - 25px);
    position: relative;
  }
  .scroll-cont {
    overflow: hidden;
  }
  .scroll-cont::-webkit-scrollbar {
    width: 5px;
    display: flex;
  }
  .scroll-cont::-webkit-scrollbar-thumb {
  }
  .scroll-cont:hover {
    overflow-y: auto;
    // width: calc(100% - 1px )
  }
}

::v-deep .el-tabs__content {
  height: calc(100% - 55px);
}
::v-deep .el-tabs__item {
  color: #cacad4;
  font-weight: 400;
  padding: 0;
}
::v-deep .el-tabs__item.is-active {
  color: #fff;
  font-weight: 500;
}
::v-deep .el-tabs__nav-wrap::after {
  background-color: transparent;
}
::v-deep .el-tabs__active-bar {
  background-color: #111224;
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
  background: #222337;
}

.infocont {
  vertical-align: middle;
  height: 18px;
  .value {
    font-size: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 18px;
    margin-left: 14px;
  }
}
</style>
